import { useMember } from './useMember';
import { MemberTable } from './MemberTable';
import { InviteUserModal } from 'ui/components/screens/modals/InviteUserModal/InviteUserModal';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { NeedProfileRegistration } from 'ui/components/agent/screens/modals/NeedProfileRegistration/NeedProfileRegistration';

export const MemberList: React.FC = () => {
    const { memberList, showSnackbar, inviteModal, needProfileModal, user, errors, setShowSnackbar, setValue, invite } =
        useMember();
    const { openModal, createModal } = inviteModal;
    const { openModal: openNeedProfileModal, createModal: createNeedProfileModal } = needProfileModal;

    if (!user) {
        return null;
    }
    return (
        <>
            <SnackBar message="招待メールを送信しました" open={showSnackbar} setOpen={setShowSnackbar} />
            {createNeedProfileModal(<NeedProfileRegistration profile_step={user.account_profile_stage} />)}
            {createModal(
                <InviteUserModal
                    onClick={invite}
                    setValue={(value) => setValue('email', value)}
                    errorMsg={errors.email?.message || ''}
                />,
            )}
            <MemberTable openModal={openModal} openNeedProfileModal={openNeedProfileModal} memberList={memberList} />
        </>
    );
};
